// @generated by protoc-gen-es v2.6.3 with parameter "keep_empty_files=true,target=js+dts"
// @generated from file proto/model/search/activity_result.proto (package carmen, syntax proto3)
/* eslint-disable */

import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import { file_proto_model_feature_activity_activity } from "../feature/activity/activity_pb";

/**
 * Describes the file proto/model/search/activity_result.proto.
 */
export const file_proto_model_search_activity_result = /*@__PURE__*/
  fileDesc("Cihwcm90by9tb2RlbC9zZWFyY2gvYWN0aXZpdHlfcmVzdWx0LnByb3RvEgZjYXJtZW4iNAoOQWN0aXZpdHlSZXN1bHQSIgoIYWN0aXZpdHkYASABKAsyEC5jYXJtZW4uQWN0aXZpdHlCKFomZ2l0aHViLmNvbS95dW5hY2FiYS9jYXJtZW4vcHJvdG8vbW9kZWxiBnByb3RvMw", [file_proto_model_feature_activity_activity]);

/**
 * Describes the message carmen.ActivityResult.
 * Use `create(ActivityResultSchema)` to create a new message.
 */
export const ActivityResultSchema = /*@__PURE__*/
  messageDesc(file_proto_model_search_activity_result, 0);

